// extracted by mini-css-extract-plugin
export default {"cautionBox":"P7-z"};